// CountdownTimer.js
import React, { useEffect, useState } from 'react';
import { MdCheckCircle } from "react-icons/md"; // Assuming you're using MdCheckCircle for the checkmark icon
import NotificationButton from './NotificationButton';
import './CountdownTimer.scss';

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState(30); // 30 seconds total
  const [showCountdown, setShowCountdown] = useState(true);
  const [showNotification, setShowNotification] = useState(false); // Added state to control the notification display

  useEffect(() => {
    let interval;
    if (timeLeft > 0 && showCountdown) {
      interval = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    } else {
      clearInterval(interval);
      if (timeLeft === 0 || !showCountdown) {
        setShowNotification(true); // Show the notification when time is up or if countdown is toggled off
      }
    }
    
    return () => clearInterval(interval);
  }, [timeLeft, showCountdown]);

  // Format the time left to display as mm:ss
  const formatTime = () => {
    const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
    const seconds = (timeLeft % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  const handleClick = () => {
    // Hide the countdown and message
    setShowCountdown(false);
  };

  return (    
    <div className="countdown-timer">
      {showCountdown ? (
        <>
          <span className="message" onClick={handleClick}>
          Your transaction will be automatically canceled after the following countdown
          </span>
          <span className="timer" onClick={handleClick}>
            {formatTime()}
          </span>
        </>
      ) :  (
        <>
        <div className="confirmation-message">
          <MdCheckCircle className="confirmation-icon" />
          <span>Transaction confirmed</span>
        </div>
        <NotificationButton />
        </>
      )}
    </div>
  );
};

export default CountdownTimer;
